import { useDispatch, useSelector } from 'react-redux';

import { BREED_DESCRIPTION_OPEN } from 'dpl/constants/query_params';
import { pushParams, resetParams } from 'dpl/actions/query_params';

export default function useBreedDescriptionModal() {
  const breedDescriptionQueryParam = useSelector(
    state => state.queryParams[BREED_DESCRIPTION_OPEN]
  );

  const isModalOpen = Boolean(breedDescriptionQueryParam);

  const dispatch = useDispatch();

  function openModal() {
    dispatch(pushParams({ [BREED_DESCRIPTION_OPEN]: true }));
  }

  function closeModal() {
    dispatch(resetParams(BREED_DESCRIPTION_OPEN));
  }

  return {
    isModalOpen,
    openModal,
    closeModal
  };
}
